@let template = drawerTemplate();
@let isSimplified = isSimplifiedShiftDrawer();

@if (isDrawerVisible() && isSimplified === true) {
  <wilson-simplified-shift-drawer
    [selectedShiftId]="selectedShiftId()"
    (closeDrawer)="closeDrawer.emit()"
    (deletionConfirmed)="deletionConfirmed.emit($event)"
  ></wilson-simplified-shift-drawer>
} @else if (isDrawerVisible() && isSimplified === false) {
  <ng-container [ngTemplateOutlet]="template"></ng-container>
}
